import type { PayloadAction } from "@reduxjs/toolkit"

import type { PlaygroundChatState } from "../playgroundTypes"

/**
 * Set the selected agent for Playground
 */
export const setPlaygroundSelectedAgent = (
  state: PlaygroundChatState,
  action: PayloadAction<string | null>
) => {
  state.selectedAgentId = action.payload
}
